import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Suppress benign cross-origin "Script error." and PayPal zoid warnings from
// surfacing in the dev error overlay. These originate from the PayPal SDK iframe
// and are harmless (no effect on production builds).
const isBenign = (msg = "") =>
  msg === "Script error." || msg.includes("zoid destroyed") || msg.includes("Script error");
window.addEventListener(
  "error",
  (e) => {
    if (isBenign(e.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true,
);
window.addEventListener("unhandledrejection", (e) => {
  const msg = (e.reason && (e.reason.message || String(e.reason))) || "";
  if (isBenign(msg)) e.preventDefault();
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
